import { getBotsByUser, getInfoBotById,getdomaine, getBotById, addBot, deleteBot, updateBotDomaine, updateBotSwitch,updateBot, trainBot, publishBot } from '../api/bot.service.js'

export default {
  state:{
    bot: {},
    bots: [],
    domaines: []
  },
  getters:{
    getAllBots(state){
      return state.bots
    },
    getBot(state){
      return state.bot
    },
    getdomaines(state){
      return state.domaines
    }
  },
  mutations:{
    setAllInfoBotsByUser(state, bots){
      state.bots = bots
    },
    setSelectedBot(state, bot){
      state.bot = bot
    },
    setBotById(state, bot){
      state.bot = bot
    },
    setDomaine(state, bot){
      state.domaines = bot
    },
    addBot(state, bot){
      state.bot = bot
      state.bots.splice(0,0, bot)
    },
    updateList(state, bot){
      state.bots.splice(0,0,bot)
    },
    updateBot(state, bot){
      state.bot = bot
    },
    updateBotSwitch(state, bot){
      state.bot = bot
    },
    updateBotDomaine(state, bot){
      state.bot = bot
    },
  },
  actions:{
    
    async setAllInfoBotsByUser(context){
      let bts = await getBotsByUser()
      let infoBots = new Array
      bts.forEach(element => {
        getBotById(element._id).then((data) => {
          infoBots.splice(0,0,data)
        })
      });
      context.commit('setAllInfoBotsByUser', infoBots)
    },
    setSelectedBot(context, bot){
      context.commit('setSelectedBot',bot)
    },
    async setBotById(context, id){
      let bot = await getBotById(id)
      context.commit('setBotById', bot)
    },
    async setDomaine(context){
      let bot = await getdomaine()
      context.commit('setDomaine', bot)
    },
    async addBot(context, bot){
      let newbot = await addBot(bot)
      context.commit('addBot', newbot)
    },
    async updateBot(context, bot){
      let upBot = await updateBot(bot)
      context.commit('updateBot', upBot)
    },
    async updateBotSwitch(context, bot){
      let upBot = await updateBotSwitch(bot)
      context.commit('updateBotSwitch', upBot)
    },
    async updateBotDomaine(context, bot){
      let upBot = await updateBotDomaine(bot)
      context.commit('updateBotDomaine', upBot)
    },
    async deleteBot(context, id){
      let upbot =  await deleteBot(id)
      let list = upbot.bot
      
      let infoBots = new Array
      list.forEach(element => {
        getBotById(element._id).then((data) => {
          infoBots.splice(0,0,data)
        })
      });
      context.commit('setAllInfoBotsByUser', infoBots)
    },
    async train(context, obj){
      console.log('test bot ', obj)
      let train  =  await trainBot(obj)
      context.commit('updateBot', train)
    },
    async setpublish(context, obj){
    let publish = await publishBot(obj)
    context.commit('updateBot',publish)
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/bot.store.js